import { createMuiTheme } from "@material-ui/core";

export default createMuiTheme({
  typography: {
    h2: {
      fontWeight: "bold",
      fontSize: "27px",
      color: "white",
    },
    h3: {
      color: "white",
      fontWeight: 100,
      fontSize: "22px",
    },
    button: {
      textTransform: "none",
    },
  },
  palette: {
    type: "light",
    primary: {
      main: "#673368",
    },
    secondary: {
      main: "#fff",
    },
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        background: "linear-gradient(to left, #673368, #CF939C)",
        fontWeight: "bold",
        color: "white",
      },
      containedSecondary: {
        backgroundColor: "#FFFFFF",
        "&:hover": {
          backgroundColor: "#FFFFFC",
          "@media (hover: none)": {
            backgroundColor: "transparent",
          },
        },
        fontWeight: "bold",
        color: "#673368",
      },
      outlinedSecondary: {
        borderStyle: "dashed",
        borderColor: "white",
        borderRadius: "5px",
        backgroundColor: "transparent",
        width: "85%",
        color: "white",
        margin: "1em auto 0 auto",
        transition: "0.3s",
        "&:hover": {
          borderStyle: "solid",
          borderColor: "#673368",
          backgroundColor: "white",
          color: "#673368",
        },
      },
    },
    // @ts-ignore
    MuiDataGridFilterForm: {
      root: {
        flexDirection: "column",
        alignItems: "flex-start",
      },
      columnSelect: {
        width: "100%",
      },
      operatorSelect: {
        width: "100%",
        marginTop: "10px",
      },
      filterValueInput: {
        width: "100%",
        marginTop: "10px",
      },
    },
  },
});
